export { default as User } from './user.model';
export { default as Component } from './component.model';
export { default as localData } from './localdata.model'
export * from './gradient.model';
export * from './custom-class.model';
export * from './box-shadow.model';
export * from './border-radius.model';
export * from './typography.model';
export * from './grid.model';